export default {
	teams: {
		teamMember: 'Teammitglied | Teammitglieder',
		accountDetails: 'Kontodaten',
		buildingAssignment: 'Liegenschaftzuordnung',
		permissions: 'Berechtigungen',
		deleteData: 'Daten löschen',
		createData: 'Daten anlegen',
		updateData: 'Daten aktualisieren',
		viewAllReports: 'Alle Meldungen ansehen',
		accessSettings: 'Zugriff auf die Einstellungen',
		hideContactInformation: 'Kontaktinformationen ausblenden',
		profilePicture: 'Profilbild',
		selectTeamMember: 'Teammitglied auswählen',
		create: 'anlegen',
		assigned_to: 'Zugewiesen an',
		active: 'Aktiv',
		deactivate: 'Deaktivieren',
		activate: 'Aktivieren',
		inactive: 'Inaktiv',
		showInactive: 'Inaktive anzeigen',
		activeManagedByErp:
			'Der Aktiv-Status kommt aus dem HausPerfekt und wird dort gepflegt.',
		karthagoPlaceholderLocked:
			'Dies ist ein Standard-Teammitglied und kann nicht geändert werden.',
	},
}
